import { CachedState } from '../../../models';

export const updateDeliveryPeriodsCacheReducer = (
  state: CachedState,
  newDate: string,
): CachedState => ({
  ...state,
  selectedDeliveryPeriods: [
    ...new Set([...(state?.selectedDeliveryPeriods ?? []), newDate]),
  ],
  lastSelectedDate: newDate,
});

export const removeDateFromCacheReducer = (
  state: CachedState,
  removeDate: string,
): CachedState => ({
  ...state,
  selectedDeliveryPeriods: (state?.selectedDeliveryPeriods ?? []).filter(
    (period) => period !== removeDate,
  ),
  lastSelectedDate: undefined,
});
